<template>
  <div>
    <div class="tree-area">
      <div class="search">
        <select class="sel_ty3" @change="changeCondition($event.target.value)">
          <!-- <option value="dept">부서</option> -->
          <option value="USER">{{$i18nUtil.trans("entity.user.user")}}</option>
        </select>
        <input type="search" v-model="searchKeyword" :placeholder="$i18nUtil.trans('search.044')"/>
        <button class="btn-primary-small black" @click="searchByKeyword">{{$i18nUtil.trans("search.039","검색")}}</button>
        <!-- <button class="btn_submit" @click="getTreeData">초기화</button> -->
      </div>
      <div class="treeselect" v-if="treeData.length > 0">
        <treeselect
          v-model="value"
          :max-height="250"
          :options="treeData"
          :default-expand-level="1"
          :always-open="alwaysOpen"
          :open-on-click="openOnClick"          
          :noOptionsText="$i18nUtil.trans('message.PartnerOrg.001','조회된 협력업체가 없습니다.')"
          :loadingText="$i18nUtil.trans('search.042')"
          @select="handleSelectNode"
        />
      </div>
      <div class="treeselect nodata" v-else>{{$i18nUtil.trans("message.GroupOrg.001","데이터가 없습니다.")}}</div>
    </div>
    <div class="organization-table-num" v-html="$i18nUtil.trans('search.000.people','총 {cnt} 명',{cnt:userCount})"></div>
    <div class="organization-table-area">
      <table class="organization-table tb-contents no-data">
        <colgroup>
          <col width="42px" />
        </colgroup>
        <thead>
          <tr>
            <th>
              <input type="checkbox" id="partnerAll" v-model="partnerAll" @click="handleSelectUser($event, '', 'ALL')"/>
              <label :for="'partnerAll'"></label>
            </th>
            <th>{{$i18nUtil.trans("entity.user.name","이름")}}</th>
            <th>{{$i18nUtil.trans("entity.user.userId","아이디")}}</th>
            <!-- <th>소속회사</th> -->
          </tr>
        </thead>
        <tbody v-if="userList.length > 0">
          <tr v-for="(user, index) in userList" :key="'partner_' + index">
            <td>
              <input
                type="checkbox"
                :value="user"
                :id="user.userKey"
                v-model="checkUsers"
                @change="handleSelectUser($event, user, '')"
              />
              <label :for="user.userKey"></label>
            </td>
            <td>{{ user.userName }}</td>
            <td>{{ user.userId }}</td>
            <!-- <td>{{ user.partnerName }}</td> -->
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="6">{{$i18nUtil.trans("message.GroupOrg.002","유저 정보가 없습니다.")}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <ul class="ref">
      <li>{{$i18nUtil.trans("message.PartnerOrg.002","* 협력업체 회원은 {project}/보드 조회, 보드 내용 작성/수정, 파일 업로드 등 일부 기능만 사용할 수 있습니다.",{project:$i18nUtil.trans("entity.project","과제")})}}</li>
      <li>{{$i18nUtil.trans("message.PartnerOrg.003","* 찾으시는 멤버가 없으시면 {project} 생성 후 멤버를 초대해 주세요.",{project:$i18nUtil.trans("entity.project","과제")})}}</li>
      <li>{{$i18nUtil.trans("message.PartnerOrg.004","* 멤버 초대 후, {project} 운영자의 승인이 필요합니다.",{project:$i18nUtil.trans("entity.project","과제")})}}</li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
//import { LOAD_CHILDREN_OPTIONS, ASYNC_SEARCH   } from '@riophae/vue-treeselect';
export default {
  data() {
    return {
      /* Tree options */
      value: [],
      alwaysOpen: true,
      multipleYn: true,
      openOnClick: true,
      parentNodeId: null,
      /*  */
      partnerAll : false,
      checkUsers: [],

      /* Rest */
      url: null,
      method: null,
      companyId: null,
      searchCondition: null,
      searchKeyword: null,
      treeData : []
    };
  },
  mounted() {
    this.changeCondition("USER");
  },
  computed: {
    ...mapState("tree", ["userList", "userCount"]),
  },
  methods: {
    /* rest Call&CallBack Action */
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    /* TreeData 변경&수정 */
    ...mapMutations("tree", ["setTreeOfUserList"]),
    async getPartnerList() {
      this.treeData = [];
      let area = document.getElementsByClassName("vue-treeselect__control");
      for (let i = 0; i < area.length; i++) {
        area[i].style.display = "none";
      }
      this.searchKeyword = null;

      let obj = this;
      let reqData = {
        url : "/api/auth/org/getOrgPartnerList",
        method : "post",
      };
      await obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          if(res.errorCode !== null) {
            let errorCode = res.errorCode;
          } else { 
            if(res.result !== null) {
             let treeList = res.result;
              
              treeList.forEach(function(item, index, arr) {
                let node = item;
                let nodeInfo = {
                  id: node.companyId,
                  label: node.companyName
                };
                obj.treeData.push(nodeInfo)
              });
            }
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    /* 검색 조건 */
    changeCondition(condition) {
      this.searchCondition = condition;
    },
    /* 검색 */
    async searchByKeyword() {
      /* 부서 & 유저 */
      let obj = this;
      let reqData = {
        url : "/api/org/searchByKeyword",
        method : "post",
        params : {
          searchCondition: obj.searchCondition,
          searchKeyword: obj.searchKeyword,
          orgTab : "PARTNER"
        }
      };
      await obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          obj.setTreeOfUserList(res.result);
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    /* 노드(부서) 선택 시 */
    handleSelectNode(node, instanceId) {
      let obj = this;
      let reqData = {
        url : "/api/org/getPartnerUserList",
        method : "post",
        params : {
          companyId : node.id
        }
      };
      this.COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          if(res.errorCode !== null) {
            let errorCode = res.errorCode;
          } else {
            if(res.result !== null) {
              obj.setTreeOfUserList(res.result);
            }
          }
        })
        .catch(function (err) {
          console.log(err);
        });
      
    },
    handleSelectUser(event, user, type) {
      let status = event.srcElement.checked;
      if(type === "ALL") {
        if(status === true) {
          this.$emit("selectUser", {type : type, data : this.userList, target: event.target.id});
          this.checkUsers = this.userList;          
        } else {
          this.$emit("deSelectUser", {type : type, data : this.userList});
          this.checkUsers = [];
        }
      } else {
        if (status === true) {
          this.$emit("selectUser", {type : type, data : user});
        } else {
          if(user.length === this.userList.length) {
            this.partnerAll = true;
          } else {
            this.partnerAll = false;
          }
          this.$emit("deSelectUser", {type : type, data : user});
        }
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/cowork/common/organization/org/PartnerOrg.vue